import { render, staticRenderFns } from "./dialog-approve-pinzhisp.vue?vue&type=template&id=1cd0ffd3&scoped=true&"
import script from "./dialog-approve-pinzhisp.vue?vue&type=script&lang=js&"
export * from "./dialog-approve-pinzhisp.vue?vue&type=script&lang=js&"
import style0 from "./dialog-approve-pinzhisp.vue?vue&type=style&index=0&id=1cd0ffd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd0ffd3",
  null
  
)

export default component.exports